import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const redminerRedisPlugin = createPlugin({
  id: 'redminer-redis',
  routes: {
    root: rootRouteRef,
  },
});

export const RedminerRedisComponent = redminerRedisPlugin.provide(
  createComponentExtension({
    name: 'RedminerRedisComponent',
    component: {
      lazy: () =>
        import('./components/RedminerRedisComponent').then(
          m => m.RedminerRedisComponent,
        ),
    },
  }),
);
